<div id="{{ componentId }}" class="vtr-ui-hardware-scan-test-result">
	<div class="item-right">
		<div class="module-result-text" [ngSwitch]="module.resultModule">
			<p id="{{ componentId }}-text-not-applicable" role="text" class="text-status" *ngSwitchCase="testResultEnum.Na">{{ 'hardwareScan.na' | translate }}</p>
			<p id="{{ componentId }}-text-pass" role="text" class="text-status" *ngSwitchCase="testResultEnum.Pass">{{ 'hardwareScan.pass' | translate }}</p>
			<p id="{{ componentId }}-text-fail" role="text" class="text-status" *ngSwitchCase="testResultEnum.Fail">{{ 'hardwareScan.fail' | translate }}</p>
			<p id="{{ componentId }}-text-warning" role="text" class="text-status" *ngSwitchCase="testResultEnum.Attention">{{ 'hardwareScan.attention' | translate }}</p>
			<p id="{{ componentId }}-text-cancelled" role="text" class="text-status" *ngSwitchCase="testResultEnum.Cancelled">{{ 'hardwareScan.cancelled' | translate }}</p>
		</div>
		<div class="module-result-icon">
			<vtr-ui-test-result-icon
				[componentId]="componentId + '-icon'"
				[testResultResponse]="module.resultModule">
			</vtr-ui-test-result-icon>
		</div>
	</div>
</div>

